<template>
  <div class="container">
    <div class="row" v-if="!all_auctions.length">
      <div class="col">
        <i
          class="bi bi-arrow-clockwise float-end text-success"
          @click="fetchAuctions()"
        ></i>
      </div>
    </div>
    <div class="row p-2" v-if="bidder_auctions.length">
      <div class="d-flex justify-content-evenly">
        <button
          class="btn btn-sm btn-warning"
          v-for="a in bidder_auctions"
          :key="a.id"
          @click="selectAuction(a.id, 'bidder')"
        >
          <LogoSmall :path="a.icon"></LogoSmall> {{ a.name }}
        </button>
      </div>
    </div>
    <div class="row p-2" v-if="viewer_auctions.length">
      <div class="d-flex justify-content-evenly">
        <button
          class="btn btn-sm btn-primary glow-button"
          v-for="a in viewer_auctions"
          :key="a.id"
          @click="selectAuction(a.id, 'viewer')"
        >
          <LogoSmall :path="a.icon"></LogoSmall> {{ a.name }}
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "@/store/index";
import { onMounted, ref, watchEffect, computed } from "vue";
import supabase from "@/supabase/config";
import LogoSmall from "../bidder/logos/LogoSmall.vue";
const store = useStore();
const all_auctions = ref([]);

const teams_list = ref([]);
onMounted(() => {
  fetchAuctions();
});
watchEffect(() => {
  if (all_auctions.value.length) {
    fetchBiddingAuctions();
  }
});
const fetchBiddingAuctions = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("bid_email", store.user.email);
  teams_list.value = teams;
};
const fetchAuctions = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("active", true)
    .neq("auctioneer_id", store.user.id);
  all_auctions.value = auctions;
};
const bidder_auctions = computed(() => {
  var arr = [];
  all_auctions.value.forEach((a) => {
    teams_list.value.forEach((t) => {
      if (t.auction_id === a.id) {
        arr.push(a);
      }
    });
  });
  return arr;
});
const viewer_auctions = computed(() => {
  var arr = [];
  all_auctions.value.forEach((a) => {
    var found = false;
    teams_list.value.forEach((t) => {
      if (t.auction_id === a.id) {
        found = true;
      }
    });
    if (!found) {
      arr.push(a);
    }
  });
  return arr;
});
const selectAuction = (id, str) => {
  store.setAuction(id);
  store.setUserType(str);
};
</script>
<style scoped>
.glow-button {
  position: relative;
  z-index: 1;
  animation: glowPulse 2s infinite ease-in-out;
}

@keyframes glowPulse {
  0% {
    box-shadow: 0 0 0px rgba(0, 123, 255, 0);
  }
  50% {
    box-shadow: 0 0 3px 1px rgba(0, 123, 255, 0.8);
  }
  100% {
    box-shadow: 0 0 0px rgba(0, 123, 255, 0);
  }
}
</style>
